export function isFileTypeAllowed(
    file: File,
    fileTypes: { [key: string]: string[] },
    allowedMimeTypes?: string[],
): boolean {
    const fileType = file.type.toLowerCase();
    let isFileAllowed = false;

    if (fileType && Object.keys(fileTypes).includes(fileType)) {
        isFileAllowed = true;
    } else if (
        allowedMimeTypes &&
        fileType &&
        allowedMimeTypes.map((m: string) => m.toLowerCase()).includes(fileType)
    ) {
        isFileAllowed = true;
    } else if (fileType === '' || !fileType) {
        const fileName = file.name.toLowerCase();
        const fileExtension = fileName.substring(fileName.lastIndexOf('.'));
        if (fileExtension) {
            for (const allowedExtensions of Object.values(fileTypes)) {
                if (allowedExtensions.includes(fileExtension)) {
                    isFileAllowed = true;
                    break;
                }
            }
        }
    }

    return isFileAllowed;
}
